import logger from './logger';
import checkAutoFill from './checkAutoFill';

logger();
checkAutoFill();
